import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'real-estate-developments-batch-price-tables',
  storeModule.createStoreModule('real-estate-developments-batch-price-tables')
)
